<div class="row">
    <ng-container>
        <!-- <div class="row gray-bg">
            <div class="input-data col-10">
                <select name="testName" [(ngModel)]="item.Name">
                    <option> {{item.Name}} </option>
                </select>
                <div class="underline-fixed"></div>
            </div>
            <div class="text-end col-2">
                <button class="remove-btn">Remove</button>
            </div>
        </div> -->
        <div class="row">
            <div class="input-data col-6" *ngFor="let field of testAttributes">
                <ng-container *ngIf="field.name.includes('Test')">
                    <label for="{{ field.name }}">{{ field.name }} <span class="star"></span> </label>
                    <input class="text-value" type="text" [(ngModel)]="field.value" name="{{ field.name }}" [value]="field.value"
                        [disabled]="field.isDisabled" />
                    <div class="underline-fixed"></div>
                </ng-container>
            </div>
            <!-- <div class="labelHead">
                <div style="margin: 0px 0px 7px 0">CPT Code</div>
                <div class="row" *ngFor="let field of item.ChildItems">
                    <div class="input-data col-5">
                        <select name="cptcode" [(ngModel)]="item.Name">
                            <option> {{field.Name}} </option>
                        </select>
                        <div class="underline-fixed"></div>
                    </div>
                    <div class="input-data col-5">
                        <select name="cptcodedesc" [(ngModel)]="field.value">
                            <option> {{field.value}} </option>
                        </select>
                        <div class="underline-fixed"></div>
                    </div>
                    <div class="input-data text-end col-2">
                        <button class="remove-btn" (click)="testModel(); removeCPTCode(field);"> X </button>
                    </div>
                </div>
            </div> -->
        </div>
    </ng-container>
</div>